import React from 'react';
import { Job } from '../../types/job';
import { QuoteJob } from '../../types/quote';
import { TFunction } from 'i18next';
import { getQuotesCountLabel } from '../../utils/jobUtils';
import { twMerge } from 'tailwind-merge';

const PILL_VARIANTS = {
  default: '',
  hub: 'bg-dark/5 text-xs text-dark',
} as const;

export type JobTagsVariant = keyof typeof PILL_VARIANTS;

interface JobTagsProps {
  job: Job | QuoteJob;
  t: TFunction;
  projectMode?: boolean;
  className?: string;
  pillClassName?: string;
  variant?: JobTagsVariant;
}

const JobTags: React.FC<JobTagsProps> = ({
  job,
  t,
  projectMode = false,
  className = '',
  pillClassName = '',
  variant = 'default',
}) => {
  const hasVisibility = 'visibility' in job;
  const hasStatus = 'status' in job;

  const variantPillClass = PILL_VARIANTS[variant];
  const mergePillClassName = twMerge(
    'inline-flex shrink-0 rounded-xl bg-[#E1E9F0] px-3 py-1 text-center text-[11px] text-secondary whitespace-nowrap',
    variantPillClass,
    pillClassName
  );

  return (
    <div className={twMerge('flex flex-wrap items-center gap-2', className)}>
      {hasVisibility && (
        <span className={mergePillClassName}>
          {t(`job_visibility_labels.${job.visibility}`, { ns: 'jobs' })}
        </span>
      )}

      {hasStatus && projectMode && (
        <span className={mergePillClassName}>
          {t(`job_statuses.${job.status}`, { ns: 'common' })}
        </span>
      )}

      {!projectMode && (
        <span className={mergePillClassName}>{getQuotesCountLabel(job as Job, t)}</span>
      )}
    </div>
  );
};

export default JobTags;
